<template>
  <div class="group relative">
    <div
      class="aspect-h-[241] aspect-w-[194] mb-4 w-full overflow-hidden bg-transparent"
    >
      <div>
        <nuxt-link :to="productLink">
          <UiLazyImg
            v-if="isEmpty(product.images)"
            :alt="productTitle || 'Image'"
            class="transition-300 absolute inset-0 h-full w-full bg-product-card-gradient"
            src="/images/no-image.webp"
            cover
          />
          <UiLazyImg
            v-else
            :alt="productTitle || 'Image'"
            class="transition-300 absolute inset-0 h-full w-full bg-product-card-gradient"
            :src="product.images[0].url"
            cover
          />
        </nuxt-link>
        <div
          class="pointer-events-none absolute left-2 top-3.5 flex max-h-full flex-col flex-wrap gap-2 md:left-4"
        >
          <div
            v-if="product.sale"
            class="rounded-sm bg-primary-light px-2 py-1 ui-text-sm text-white md:px-4 md:py-2.5"
          >
            {{ $t("sale") }}
          </div>
          <template v-if="product.badges">
            <div
              v-for="(badge, idx) in product.badges"
              :key="idx"
              class="rounded-sm bg-primary-light px-2 py-1 ui-text-sm text-white md:px-4 md:py-2.5"
            >
              {{ badge.title }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="px-2 space-y-2">
      <NuxtLink
        :to="productLink"
        class="block w-full truncate ui-text-sm text-white uppercase bold"
      >
        {{ productTitle }}
      </NuxtLink>
      <div class="ui-text-xs text-white">
        <p v-if="product.sale">
          <b class="font-medium">{{ $n(discountValue, "currency") }}</b>
          ({{ product.sale_value }}% OFF)
        </p>
        <p :class="[product.sale ? 'line-through' : '']">
          {{ $n(productPrice, "currency") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CatalogData } from "ecom-types";
import { CardProduct } from "~/composables";
import { sizesSlugs } from "~/configs";

const props = defineProps<{ product: CardProduct | CatalogData }>();
const { productTitle, productLink, productPrice, discountValue } = useProduct(
  props.product as CatalogData,
  sizesSlugs,
);

// const link = computed(() => {
//   const query = props.product.default_sku
//     ? `${props.product.embeded ? "?config=" : "?configuration_id="}${
//         props.product.default_sku
//       }`
//     : "";
//   return localePath(`/product/${props.product.slug}${query}`);
// });
</script>
